module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/status_agente-7f89b17b49b696516d6dad5c9ce54d71.gif";